module.exports = __webpack_public_path__ + "static/media/shieldActive.f74881ab.svg";